import { createLUTComputeShader, createCopyComputeShader } from './shaders.js';
import { createSampler } from './resources.js';
/**
 * 创建LUT处理计算管线
 * @param device WebGPU设备
 * @param highPerformance 是否使用高性能模式
 * @returns 计算管线
 */
export function createLUTComputePipeline(device, highPerformance = false) {
    const shader = createLUTComputeShader(device, highPerformance);
    return device.createComputePipeline({
        layout: 'auto',
        compute: {
            module: shader,
            entryPoint: 'main'
        }
    });
}
/**
 * 创建图像复制计算管线
 * @param device WebGPU设备
 * @returns 计算管线
 */
export function createCopyComputePipeline(device) {
    const shader = createCopyComputeShader(device);
    return device.createComputePipeline({
        layout: 'auto',
        compute: {
            module: shader,
            entryPoint: 'main'
        }
    });
}
/**
 * 计算最优的工作组调度参数
 * @param width 图像宽度
 * @param height 图像高度
 * @param highPerformance 是否使用高性能模式
 * @returns 工作组调度参数
 */
export function computeWorkgroupDispatch(width, height, highPerformance = false) {
    // 根据工作组大小计算调度参数
    const workgroupSize = highPerformance ? 32 : 16;
    return [
        Math.ceil(width / workgroupSize),
        Math.ceil(height / workgroupSize)
    ];
}
/**
 * 创建LUT处理绑定组
 * @param device WebGPU设备
 * @param pipeline 计算管线
 * @param resources 纹理资源
 * @param uniformBuffer 统一缓冲区
 * @returns 绑定组
 */
export function createLUTBindGroup(device, pipeline, resources, uniformBuffer) {
    const sampler = createSampler(device);
    const maskSampler = createSampler(device);
    const entries = [
        {
            binding: 0,
            resource: resources.inputTextureView
        },
        {
            binding: 1,
            resource: resources.lutTextureView
        },
        {
            binding: 2,
            resource: resources.outputTextureView
        },
        {
            binding: 3,
            resource: sampler
        }
    ];
    // 如果存在遮罩纹理，添加遮罩相关的绑定
    if (resources.maskTextureView) {
        entries.push({
            binding: 4,
            resource: resources.maskTextureView
        }, {
            binding: 5,
            resource: maskSampler
        }, {
            binding: 6,
            resource: {
                buffer: uniformBuffer
            }
        });
    }
    else {
        // 如果没有遮罩纹理，使用占位符纹理和采样器
        entries.push({
            binding: 4,
            resource: resources.inputTextureView // 使用输入纹理作为占位符
        }, {
            binding: 5,
            resource: sampler // 使用相同的采样器
        }, {
            binding: 6,
            resource: {
                buffer: uniformBuffer
            }
        });
    }
    return device.createBindGroup({
        layout: pipeline.getBindGroupLayout(0),
        entries
    });
}
/**
 * 创建图像复制绑定组
 * @param device WebGPU设备
 * @param pipeline 计算管线
 * @param resources 纹理资源
 * @returns 绑定组
 */
export function createCopyBindGroup(device, pipeline, resources) {
    return device.createBindGroup({
        layout: pipeline.getBindGroupLayout(0),
        entries: [
            {
                binding: 0,
                resource: resources.inputTextureView
            },
            {
                binding: 1,
                resource: resources.outputTextureView
            }
        ]
    });
}
//# sourceMappingURL=pipeline.js.map